import React from 'react';

function ChatListItem({ chat, isSelected, onClick, formatTime }) {
  const unread = !!chat.unread;
  const initials = (chat.phone_number || '').replace('+', '').slice(-2).toUpperCase();

  return (
    <li
      onClick={onClick}
      className={`
        flex items-center gap-3 p-4 cursor-pointer border-b border-slate-800 
        transition-colors
        ${isSelected ? 'bg-slate-800' : 'hover:bg-slate-800/50'}
      `}
    >
      {/* Avatar */}
      <div 
        className={`
          w-12 h-12 rounded-full flex items-center justify-center 
          flex-shrink-0 font-bold text-sm font-montserrat
          ${unread 
            ? 'bg-brand-green text-slate-900' 
            : 'bg-slate-700 text-white'
          }
        `}
      >
        {initials || '👤'}
      </div>

      {/* Content */}
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between gap-2 mb-1">
          <div 
            className={`
              text-sm truncate font-montserrat
              ${unread ? 'font-bold text-white' : 'font-semibold text-slate-200'}
            `}
          >
            {chat.phone_number}
          </div>
          <div className="text-xs text-slate-400 flex-shrink-0 font-montserrat">
            {formatTime(chat.updated_at)}
          </div>
        </div>
        
        <div className="flex items-center gap-2">
          <div 
            className={`
              text-sm truncate font-montserrat
              ${unread ? 'font-semibold text-white' : 'text-slate-400'}
            `}
          >
            {chat.last_message || ' '}
          </div>
          {unread && (
            <div className="w-2 h-2 rounded-full bg-brand-green flex-shrink-0" />
          )}
        </div>
      </div>
    </li>
  );
}

export default ChatListItem;